function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkylineWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 164.35,
    height: 64,
    viewBox: "0 0 164.35 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 164.35,
    height: 64,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m35.88,28.48h0l-16.13-6.03-13.51,5.06v-3.76l.79-.3,12.72-4.76,14.22,5.32v-3.55l-12.56-4.7v-3.42c1.44.27,3.35.25,5.29-.9,2.05-1.21,5.15,1,5.18,1.02l2.66,1.99v-3.32s0-7.32,0-7.32l-.66-.5c-.2-.15-4.86-3.58-8.86-1.22-2.12,1.25-4.24.1-4.4,0l-2.54-1.6.02,3.02v12.24l-11.06,4.14h0s-1.63.58-1.63.58l-2.41.85v10.94l3.25-1.21,13.51-5.06,16.04,6v9.18h0c.08,4.81-2.3,9.28-7.12,13.31-1.99,1.66-4.08,2.97-5.79,3.91l-3.13-16.35-3.13,16.35c-1.71-.94-3.8-2.24-5.79-3.91-5.46-4.56-7.8-9.69-6.96-15.24l15.88-5.94,12.79,4.79v-3.55l-12.79-4.79L.97,36.78l-.19.9c-1.49,7.11,1.28,13.83,7.99,19.41,4.91,4.08,10.16,6.11,10.38,6.19l.59.23.59-.23c.22-.08,5.48-2.11,10.38-6.19,5.56-4.62,8.41-10.02,8.38-15.77h0v-11.64l-3.24-1.19ZM21.41,7.03v-1.18c1.44.27,3.35.25,5.29-.9,1.47-.87,3.48.02,4.51.61v2.82c-.91-.35-1.98-.62-3.11-.62-1.02,0-2.08.23-3.09.83-1.38.82-2.76.61-3.6.34v-1.9Z",
    style: {
      fill: "#27adff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m53.14,36.44c-1.17-.5-2.1-1.22-2.78-2.16-.68-.94-1.03-2.05-1.05-3.34h4.51c.06.86.37,1.54.92,2.04.55.5,1.31.75,2.27.75s1.75-.24,2.31-.71c.56-.47.84-1.09.84-1.85,0-.62-.19-1.13-.57-1.53-.38-.4-.86-.72-1.43-.95-.57-.23-1.36-.49-2.36-.77-1.36-.4-2.47-.8-3.32-1.19-.85-.39-1.58-.98-2.19-1.77-.61-.79-.92-1.85-.92-3.17,0-1.24.31-2.32.93-3.25.62-.92,1.49-1.63,2.62-2.12,1.12-.49,2.41-.74,3.85-.74,2.16,0,3.92.53,5.28,1.58s2.1,2.52,2.24,4.4h-4.63c-.04-.72-.35-1.32-.92-1.79-.57-.47-1.33-.71-2.27-.71-.82,0-1.48.21-1.97.63-.49.42-.74,1.03-.74,1.83,0,.56.18,1.03.56,1.4.37.37.83.67,1.38.9.55.23,1.33.5,2.33.8,1.36.4,2.48.8,3.34,1.2.86.4,1.6,1,2.22,1.8.62.8.93,1.85.93,3.16,0,1.12-.29,2.16-.87,3.13-.58.96-1.43,1.73-2.56,2.3-1.12.57-2.45.86-4,.86-1.46,0-2.78-.25-3.95-.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80,36.98l-7.64-9.35v9.35h-4.21V16h4.21v9.41l7.64-9.41h5.08l-8.66,10.4,8.9,10.58h-5.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.77,16l-7.09,13.68v7.31h-4.21v-7.31l-7.12-13.68h4.75l4.51,9.59,4.48-9.59h4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.41,33.64h6.91v3.34h-11.12V16h4.21v17.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.21,16v20.98h-4.21V16h4.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.31,36.98h-4.21l-9.53-14.4v14.4h-4.21V15.97h4.21l9.53,14.43v-14.43h4.21v21.01Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.66,19.39v5.26h7.06v3.34h-7.06v5.56h7.97v3.43h-12.18V15.97h12.18v3.43h-7.97Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54.58,51.85c.05.13.1.25.15.38.05-.13.1-.26.15-.38.05-.12.11-.24.18-.37l3.44-6.25c.06-.11.13-.17.19-.2.07-.02.16-.04.28-.04h1.01v10.16h-1.21v-7.47c0-.1,0-.21,0-.32,0-.11.01-.23.02-.35l-3.48,6.35c-.12.21-.28.32-.5.32h-.2c-.21,0-.38-.11-.5-.32l-3.56-6.37c.01.12.02.24.03.36s.01.23.01.33v7.47h-1.21v-10.16h1.01c.12,0,.22.01.28.04.07.02.13.09.19.2l3.51,6.25c.07.11.12.23.17.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.09,55.16h-1.06c-.12,0-.22-.03-.3-.09-.08-.06-.13-.14-.17-.23l-.95-2.45h-4.56l-.95,2.45c-.03.09-.09.16-.17.23-.08.07-.18.1-.3.1h-1.06l4.06-10.16h1.4l4.06,10.16Zm-6.66-3.77h3.79l-1.6-4.13c-.1-.26-.21-.57-.3-.96-.05.19-.1.37-.15.54-.05.16-.1.31-.15.43l-1.6,4.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.17,50.92v4.24h-1.37v-10.16h2.87c.64,0,1.2.07,1.67.2.47.13.85.32,1.16.56.31.25.53.54.68.89.15.35.22.74.22,1.17,0,.36-.06.69-.17,1.01s-.28.59-.49.84c-.22.25-.48.46-.79.63-.31.17-.66.31-1.05.4.17.1.32.24.45.43l2.96,4.03h-1.22c-.25,0-.44-.1-.55-.29l-2.64-3.63c-.08-.11-.17-.19-.26-.24s-.24-.07-.43-.07h-1.04Zm0-1h1.44c.4,0,.75-.05,1.06-.15.3-.1.56-.23.77-.41.21-.18.36-.39.46-.63.1-.25.16-.52.16-.82,0-.61-.2-1.06-.6-1.37-.4-.31-.99-.46-1.78-.46h-1.5v3.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.7,55.16h-1.38v-10.16h1.38v10.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.68,45.05c.06.03.13.09.2.19l5.88,7.66c-.01-.12-.02-.24-.03-.36,0-.12,0-.23,0-.34v-7.2h1.21v10.16h-.69c-.11,0-.2-.02-.27-.06-.07-.04-.15-.1-.22-.19l-5.88-7.65c0,.12.02.23.02.35,0,.11,0,.22,0,.31v7.24h-1.21v-10.16h.71c.12,0,.21.02.27.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.96,45v1.12h-4.88v3.37h3.95v1.08h-3.95v3.47h4.88v1.12h-6.26v-10.16h6.26Z",
    style: {
      fill: "#fff"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkylineWhite);
export default __webpack_public_path__ + "static/media/skyline-white.dd499267f2a949242fa99a7afe1ba63c.svg";
export { ForwardRef as ReactComponent };